import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/employees/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { tab: 'ACTIVE' }),
});
